import ListItem from "../../../components/ListItem";
import React, { useState } from "react";
import { $ } from "../../../../../vendor";

const InsuranceListItem = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const toggleElement = (ev, key) => {
    $("#insurance_certificates-panel-" + key).toggleClass("active");
    $("#reservations-item-" + key).toggleClass("toggled");
    searchParams.set("item", key);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        order={null}
        id={props.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        menu={props.menu}
        refLink={props.refLink}
        length={props.length}
        extra4={true}
        toggleElement={toggleElement}
        certificates={props.certificates}
        insurance={props.insurance}
        dispatch={props.dispatch}
      />
    </>
  );
};

export default InsuranceListItem;
